module.exports = "<div class=\"ngx-d3-tooltip {{ cssClasses }}\" [ngClass]=\"{ 'ngx-d3-tooltip_visible': isVisible }\">\n  <div class=\"arrow\"></div>\n  <ng-template d3TooltipHost></ng-template>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/andyperlitch/repos/ngx-d3-tooltip/src/app/modules/d3-tooltip/d3-tooltip.component.html
// module id = ../../../../../src/app/modules/d3-tooltip/d3-tooltip.component.html
// module chunks = main